module.exports = __webpack_public_path__ + "img/very-happy-emoji.729406af.svg";